'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorizontalScrollbar = function (_React$Component) {
  (0, _inherits3.default)(HorizontalScrollbar, _React$Component);

  /* istanbul ignore next */
  function HorizontalScrollbar() {
    (0, _classCallCheck3.default)(this, HorizontalScrollbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorizontalScrollbar.__proto__ || (0, _getPrototypeOf2.default)(HorizontalScrollbar)).call(this));

    _this.state = {
      width: 0,
      dragging: false,
      start: 0
    };

    _this.jump = _this.jump.bind(_this);
    _this.startDrag = _this.startDrag.bind(_this);
    return _this;
  }

  /* istanbul ignore next */


  (0, _createClass3.default)(HorizontalScrollbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.calculateSize(this.props);

      // Put the Listener
      document.addEventListener('mousemove', this.onDrag.bind(this));
      document.addEventListener('touchmove', this.onDrag.bind(this));
      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener('touchend', this.stopDrag.bind(this));
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.wrapper.width !== this.props.wrapper.width || nextProps.area.width !== this.props.area.width) this.calculateSize(nextProps);
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the Listener
      document.removeEventListener('mousemove', this.onDrag.bind(this));
      document.removeEventListener('touchmove', this.onDrag.bind(this));
      document.removeEventListener('mouseup', this.stopDrag.bind(this));
      document.removeEventListener('touchend', this.stopDrag.bind(this));
    }

    /* istanbul ignore next */

  }, {
    key: 'onDrag',
    value: function onDrag(event) {
      var _this2 = this;

      if (this.state.dragging) {
        // Make The Parent being in the Dragging State
        this.props.onDragging();

        event.preventDefault();
        event.stopPropagation();

        var e = event.changedTouches ? event.changedTouches[0] : event;

        var xMovement = e.clientX - this.state.start;
        var xMovementPercentage = xMovement / this.props.wrapper.width * 100;

        // Update the last e.clientX
        this.setState({ start: e.clientX }, function () {
          // The next Horizontal Value will be
          var next = _this2.props.scrolling + xMovementPercentage;

          // Tell the parent to change the position
          _this2.props.onChangePosition(next, 'horizontal');
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'startDrag',
    value: function startDrag(event) {
      event.preventDefault();
      event.stopPropagation();

      var e = event.changedTouches ? event.changedTouches[0] : event;

      // Prepare to drag
      this.setState({
        dragging: true,
        start: e.clientX
      });
    }

    /* istanbul ignore next */

  }, {
    key: 'stopDrag',
    value: function stopDrag() {
      if (this.state.dragging) {
        // Parent Should Change the Dragging State
        this.props.onStopDrag();
        this.setState({ dragging: false });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'jump',
    value: function jump(e) {
      var _this3 = this;

      var isContainer = e.target === this.container;

      if (isContainer) {
        // Get the Element Position
        var position = this.scrollbar.getBoundingClientRect();

        // Calculate the horizontal Movement
        var xMovement = e.clientX - position.left;
        var centerize = this.state.width / 2;
        var xMovementPercentage = xMovement / this.props.wrapper.width * 100 - centerize;

        // Update the last e.clientX
        this.setState({ start: e.clientX }, function () {
          // The next Horizontal Value will be
          var next = _this3.props.scrolling + xMovementPercentage;

          // Tell the parent to change the position
          _this3.props.onChangePosition(next, 'horizontal');
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'calculateSize',
    value: function calculateSize(source) {
      // Scrollbar Width
      this.setState({ width: source.wrapper.width / source.area.width * 100 });
    }

    /* istanbul ignore next */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var className = function className(base, name, pos, act, isAct) {
        return [base + name, base + name + pos, isAct ? base + name + act : '', isAct ? base + name + pos + act : ''].join(' ');
      };

      if (this.state.width < 100) {
        return _react2.default.createElement(
          'div',
          {
            className: className('quiver-scrollbar__scroll', '-track', ':horizontal', ':dragging', this.state.dragging || this.props.draggingFromParent),
            ref: function ref(c) {
              _this4.container = c;
            },
            onClick: this.jump,
            style: { position: 'absolute' }
          },
          _react2.default.createElement('div', {
            className: className('quiver-scrollbar__scroll', '-thumb', ':horizontal', ':dragging', this.state.dragging || this.props.draggingFromParent),
            ref: function ref(c) {
              _this4.scrollbar = c;
            },
            onTouchStart: this.startDrag,
            onMouseDown: this.startDrag,
            style: {
              position: 'relative',
              width: this.state.width + '%',
              left: this.props.scrolling + '%'
            }
          })
        );
      }
      return null;
    }
  }]);
  return HorizontalScrollbar;
}(_react2.default.Component);

// The Props


HorizontalScrollbar.propTypes = {
  draggingFromParent: _react2.default.PropTypes.bool.isRequired,
  scrolling: _react2.default.PropTypes.number.isRequired,
  wrapper: _react2.default.PropTypes.shape().isRequired,
  area: _react2.default.PropTypes.shape().isRequired,
  onChangePosition: _react2.default.PropTypes.func.isRequired,
  onDragging: _react2.default.PropTypes.func.isRequired,
  onStopDrag: _react2.default.PropTypes.func.isRequired
};

exports.default = HorizontalScrollbar;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Scrollbar/HorizontalScrollbar.js
// module id = 638
// module chunks = 11